import { createAsyncThunk } from "@reduxjs/toolkit";
import { verifyMailApi } from "./api";

export const verifyMail = createAsyncThunk("verifyMail", async (payload) => {
	try {
		const res = await verifyMailApi(payload);
		return res.data;
	} catch (err) {
		throw err.response.data;
	}
});
